import { FolderAddOutlined } from '@ant-design/icons'
import { Popconfirm, Tooltip } from 'antd'
import { getOperationName } from 'apollo-link'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { GetViewerFollowingGroupsDocument, Group, useGroupArchiveMutation } from '@/generated/graphql'

import s from './archive-group.module.less'

export interface ArchiveGroupProps {
  group: Group
  setDropDownVisible?: React.Dispatch<React.SetStateAction<boolean>>
}

export const ArchiveGroup: React.FC<ArchiveGroupProps> = ({ group, setDropDownVisible }) => {
  const history = useHistory()
  const [t] = useTranslation()

  const [archiveGroup] = useGroupArchiveMutation({
    variables: {
      groupId: group.groupId,
    },
    refetchQueries: [getOperationName(GetViewerFollowingGroupsDocument)!],
    onCompleted: () => {
      history.push(`/groups`)
    },
  })

  return (
    <Popconfirm
      title={t('archive.confirm')}
      okText={t('archive.yes')}
      cancelText={t('archive.cancel')}
      onConfirm={() => {
        setDropDownVisible && setDropDownVisible(false)
        archiveGroup()
      }}
      onCancel={() => setDropDownVisible && setDropDownVisible(false)}
      placement={'bottom'}
    >
      <Tooltip title={t('groups.archiveGroupTooltip')}>
        <div className={s.menu} onClick={() => setDropDownVisible && setDropDownVisible(true)}>
          <FolderAddOutlined style={{ marginRight: 8 }} />
          {t('archive.archive')}
        </div>
      </Tooltip>
    </Popconfirm>
  )
}
